import { render, staticRenderFns } from "./BannerPage.vue?vue&type=template&id=598662b3&scoped=true&"
import script from "./BannerPage.vue?vue&type=script&lang=js&"
export * from "./BannerPage.vue?vue&type=script&lang=js&"
import style0 from "./BannerPage.vue?vue&type=style&index=0&id=598662b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598662b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
